import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import username from 'flarum/common/helpers/username';

/**
 * "An album you follow has new pictures in it."
 */
export default class NewPictureNotification extends Notification {
  icon() {
    return 'fas fa-images';
  }
  href() {
    const subject = this.attrs.notification.subject();
    return subject ? app.route('atrium.album', {
      slug: subject.slug()
    }) : app.route('atrium.index');
  }
  content() {
    const notification = this.attrs.notification;
    return app.translator.trans('ernestdefoe-atrium.forum.notifications.new_pictures', {
      // 🚨 See the sibling components: `user` is a reserved placeholder name.
      username: username(notification.fromUser()),
      count: notification.content()?.count || 1
    });
  }
  excerpt() {
    return this.attrs.notification.subject()?.title() || null;
  }
}
flarum.reg.add('ernestdefoe-atrium', 'forum/components/NewPictureNotification', NewPictureNotification);